export enum SAVE_METER_ERROR {
    IS_SMART_METER = 'IS_SMART_METER',
    METER_ALREADY_BILLED = 'METER_ALREADY_BILLED',
    METERREADING_EXISTS = 'METERREADING_EXISTS',
    NO_ACTIVE_CONTRACT = 'NO_ACTIVE_CONTRACT',
    DEFAULT = 'DEFAULT',
    NONE = ''
}
